import './App.scss';

function App() {
  return (
    <div className="page">
      {/* Header */}
      <header className="header">
        <div className="container header__inner">
          <div className="header__brand">
            <img src="/logo.png" alt="Geottuse logo" />
            <span>Geottuse</span>
          </div>
          <div className="header__tagline">Simplify Software</div>
        </div>
      </header>

      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: `url(/cover.jpg)` }}
      >
        <div className="hero__content">
          <h1>Empowering the World Through Simplicity</h1>
          <p>
            We build technology that removes complexity and makes software
            accessible to everyone.
          </p>
        </div>

        {/* Scroll cue */}
        <div className="hero__scroll">↓</div>
      </section>

      {/* About */}
      <section className="section">
        <div className="container grid grid-2 grid--reverse">
          <div className="image-card">
            <img src="/prevgen.jpg" alt="Product preview" />
          </div>

          <div className="text-block">
            <h2>Built for Everyone</h2>
            <p>
              Designed with simplicity at its core, our technology is accessible
              to all ages — including seniors — without frustration.
            </p>
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="section section--light">
        <div className="container center narrow">
          <h2>The Future We're Building</h2>
          <p>
            Technology should adapt to people — not the other way around.
            We are shaping a future where software feels natural,
            intuitive, and effortless.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="center narrow">
            <h2>Our Products</h2>
            <p>
              We build simple, powerful tools designed to make everyday digital
              experiences more intuitive.
            </p>
          </div>

          <div className="apps-grid">
            <div className="app-card">
              <div className="app-icon">
                <img src="/logos/plamogee.png" alt="Plamogee" />
              </div>

              <h3>Plamogee</h3>

              <p>
                A secure, encrypted note-taking platform built for clarity and focus.
              </p>

              <span className="app-meta"></span>
            </div>

            <div className="app-card">
              <div className="app-icon">
                <img src="/logos/plogee.png" alt="Plogee" />
              </div>

              <h3>Plogee</h3>

              <p>
                An AI marketing platform that enables everyone to do marketing
              </p>

              <span className="app-meta"></span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        © {new Date().getFullYear()} Geottuse™ · All Rights Reserved
      </footer>
    </div>
  );
}

export default App;
